import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

const useScheduledMeasure = (elementRef, measure) => {
  const rafRef = useRef(null);

  const scheduleMeasure = useCallback(() => {
    if (rafRef.current != null)
      cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null;
      measure();
    });
  }, [measure]);

  useLayoutEffect(() => {
    measure();
  }, [measure]);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;
    const observer = new ResizeObserver(() => scheduleMeasure());
    observer.observe(element);
    return () => {
      observer.disconnect();
      if (rafRef.current != null)
        cancelAnimationFrame(rafRef.current);
    };
  }, [elementRef, scheduleMeasure]);
};

export default useScheduledMeasure;